import React from 'react';
import HRDepartmentPage from '../../pages/hr/department-management.js';
import ViewDepartmentPage from '../../pages/hr/department-management.js/view-departments';
import ProtectedRoute from '../protected';

export const HRDepartmentsRoutes = [
  <ProtectedRoute exact path='/department' component={HRDepartmentPage} />,
  <ProtectedRoute exact path='/department/view/:id' component={ViewDepartmentPage} />,
];